import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

/**
 * Код счётчика из кабинета Яндекс Метрики.
 * Вставьте сюда сниппет целиком: блок `<script>` и `<noscript>`.
 */
const YANDEX_METRIKA_CODE = `<!-- Yandex.Metrika counter --> <script type="text/javascript">     (function(m,e,t,r,i,k,a){         m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};         m[i].l=1*new Date();         for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}         k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)     })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=113776138', 'ym');      ym(113776138, 'init', {ssr:true, webvisor:true, trackHash:true, clickmap:true, ecommerce:"dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true}); </script> <noscript><div><img src="https://mc.yandex.ru/watch/113776138" style="position:absolute; left:-9999px;" alt="" /></div></noscript> <!-- /Yandex.Metrika counter -->`;

type Ym = (counterId: number, method: string, url: string, options?: { title?: string }) => void;

let injected = false;

function counterId(code: string): number | null {
  const match = code.match(/ym\(\s*(\d+)\s*,\s*['"]init['"]/) ?? code.match(/mc\.yandex\.ru\/watch\/(\d+)/);
  if (!match) return null;
  const id = Number(match[1]);
  return Number.isFinite(id) ? id : null;
}

function injectHtml(html: string) {
  const container = document.createElement('div');
  container.hidden = true;
  container.innerHTML = html;
  document.body.appendChild(container);
  container.querySelectorAll('script').forEach((old) => {
    const script = document.createElement('script');
    for (const attr of old.attributes) {
      script.setAttribute(attr.name, attr.value);
    }
    script.text = old.textContent ?? '';
    old.replaceWith(script);
  });
}

/** Счётчик на всех страницах. Для переходов внутри SPA шлёт hit отдельно: init считает только первую загрузку. */
export const YandexMetrika: React.FC = () => {
  const location = useLocation();
  const id = counterId(YANDEX_METRIKA_CODE);
  const skipFirstHit = useRef(true);

  useEffect(() => {
    const code = YANDEX_METRIKA_CODE.trim();
    if (!code || injected) return;
    injected = true;
    injectHtml(code);
  }, []);

  useEffect(() => {
    if (!id) return;
    if (skipFirstHit.current) {
      skipFirstHit.current = false;
      return;
    }
    const ym = (window as Window & { ym?: Ym }).ym;
    ym?.(id, 'hit', window.location.href, { title: document.title });
  }, [id, location.pathname, location.search, location.hash]);

  return null;
};
